import { render, staticRenderFns } from "./RegSetUser.vue?vue&type=template&id=41634cc0&scoped=true"
import script from "./RegSetUser.vue?vue&type=script&lang=js"
export * from "./RegSetUser.vue?vue&type=script&lang=js"
import style0 from "./RegSetUser.vue?vue&type=style&index=0&id=41634cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41634cc0",
  null
  
)

export default component.exports